import { FC } from 'react'

import { CircularProgress, Stack, Typography, useTheme } from '@mui/material'
import { AutoCompleteOption } from '@/components/inputs/LicenseCompetitionsAutocomplete/LicenseCompetitionsAutocomplete'

import { AvailableCompetitionsList } from './AvailableCompetitionsList'

type AvailableCompetitionsSectionProps = {
  unselectedCompetitionsList: AutoCompleteOption[]
  selectedCompetitionIds: string[]
  onCompetitionToggle: (competition: AutoCompleteOption) => void
  debouncedSearchQuery: string
  isLoading: boolean
  hasMore: boolean
  isLoadingMore: boolean
  isAutoLoading: boolean
  currentPage: number
  loadMore: (page: number) => void
  selectedCompetitionsListLength: number
}

export const AvailableCompetitionsSection: FC<AvailableCompetitionsSectionProps> = ({
  unselectedCompetitionsList,
  selectedCompetitionIds,
  onCompetitionToggle,
  debouncedSearchQuery,
  isLoading,
  hasMore,
  isLoadingMore,
  isAutoLoading,
  currentPage,
  loadMore,
  selectedCompetitionsListLength
}) => {
  const theme = useTheme()

  if (!unselectedCompetitionsList.length) {
    return null
  }

  return (
    <Stack
      sx={{
        flex: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.common.white
            : theme.palette.background.default
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          p: 1,
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Typography variant="subtitle2">
          Available Competitions ({unselectedCompetitionsList.length})
        </Typography>
        {isLoadingMore && <CircularProgress size={14} />}
      </Stack>
      <AvailableCompetitionsList
        unselectedCompetitionsList={unselectedCompetitionsList}
        selectedCompetitionIds={selectedCompetitionIds}
        onCompetitionToggle={onCompetitionToggle}
        debouncedSearchQuery={debouncedSearchQuery}
        isLoading={isLoading}
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
        isAutoLoading={isAutoLoading}
        currentPage={currentPage}
        loadMore={loadMore}
        selectedCompetitionsListLength={selectedCompetitionsListLength}
      />
    </Stack>
  )
}
